import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useState } from "react";
import { FormControl, IconButton, Popover } from "@mui/material";
import React from "react";
import { FeatureFlagGuard } from "features/appFeatures/FeatureFlagGuard";
import { DossierExportButton } from "./DossierExportButton";
import { Dossier } from "types/Dossier";
import { AppFeature } from "features/appFeatures/types/AppFeature";
import { DossierRemoveButton } from "./DossierRemoveButton";
import { DossierRetryFailedButton } from "./DossierRetryFailedButton";

export interface DossierActionsPopOverProps {
    dossier: Dossier;
}

export function DossierActionsPopOver(props: DossierActionsPopOverProps) {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation(); // Prevents parent onRowClick
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <>
            <IconButton
                aria-label="settings"
                onClick={handleClick}
            >
                <MoreVertIcon />
            </IconButton>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <FormControl
                    sx={{ m: 1, minWidth: 120, alignItems: "flex-start" }}
                    size="small"
                >
                    <FeatureFlagGuard
                        accessibleWithFeatureFlags={[
                            AppFeature.CaseManagementExports,
                        ]}
                    >
                        <DossierExportButton
                            dossierId={props.dossier.id}
                            buttonText={"Exports"}
                            enabled={true}
                        />
                    </FeatureFlagGuard>

                    <DossierRemoveButton dossier={props.dossier} />

                    <DossierRetryFailedButton dossier={props.dossier} />
                </FormControl>
            </Popover>
        </>
    );
}
